<template>
  <div class="go-in">
    <banner img="g_bg2.jpg" title="历思生物" />
    <div class="section" v-loading="loading">
      <div class="section-content">
        <div class="content-summary">
          <div class="summary-left">
            <p class="title">公司简介</p>
            <p class="eTitle">ABOUT US</p>
            <p class="content">
              {{`厦门历思生物技术有限公司（以下简称历思生物），为厦门历思科技服务有限公司（以下简称历思）全资子公司。
              历思生物成立的目的是为了历思在生物技术领域能更专业、更系统地发展，因此承接历思在生物科技方面的主要业务与技术。目前规划方向为五个领域：
              1、禁毒及司法鉴定领域分析仪器的研发与生产，以及配套的上下游物证技术产品的研发、生产、销售。
              2、海洋生物检验设备及在线监控系统设施的研发生产销售，含系统工程建设。
              3、流行病的在线预警系统研发、生产、销售与施工。
              4、食品快速检测设备、在线检测设备、高端实验分析设备及预警系统，以及食品物证相关取证设备的研发、生产、销售；食品物证证据化培训等。
              5、环境快速检测设备、在线检测设备、高端实验分析设备及预警系统，以及环境物证的相关取证设备的研发、生产、销售；环境物证证据化培训等。`}}

            </p>
          </div>
          <div class="summary-right">
            <img src="../assets/goin/build1.jpg" alt="历思生物" />
          </div>
        </div>
        <el-divider class="el-divider-active">
          <i class="el-icon-arrow-down el-icon-arrow-down-active"></i>
        </el-divider>
        <!-- 发展历程 -->
        <!-- <div class="content-course">
          <div class="top">
            <h3>发展历程</h3>
            <p>DEVELOPMENT</p>
            <div class="border"></div>
            <div class="timeline"></div>
          </div>
          <div class="course-time">
            <swiper :options="swiperOption" ref="mySwiper">
              <swiper-slide v-for="(item,index) in courseList" :key="index">
                <div class="time-show">
                  <div class="time-show-item" v-for="(courseOne,one) in item" :key="one">
                    <div class="item-top" :class="{'order-top' : one%2===1}"></div>
                    <el-divider>
                      <i class="el-icon-mobile-phone"></i>
                    </el-divider>
                    <div class="item-bottom" :class="{'order' : one%2===1}">
                      <div class="item-bottom-content">
                        <p>{{courseOne.Content}}</p>
                        <p>{{courseOne.Year}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>
        </div> -->

        <div class="content-culture">
          <h3>企业文化</h3>
          <h3>CULTURE</h3>
          <p>尊重、团结、真诚、拼搏、规范、创新</p>
          <span>用文化凝聚人心</span>
          <span>用制度驾驭任性</span>
          <span>用品牌成就人生</span>
        </div>
        <!-- 公司荣誉 -->
        <div class="content-honor">
          <div class="honor-big-img">
            <el-dialog  custom-class="dialodStyle" :title="dialogTitle" :visible.sync="dialogTableVisible">
              <img v-lazy="dialogUrl" alt="公司荣誉" />
            </el-dialog>
          </div>
          <div class="top">
            <h3>公司荣誉</h3>
            <p>HONOR</p>
            <div class="border"></div>
          </div>
          <ul class="honor-show">
            <li v-for="(honor,index) in honorList" :key="index">
              <img
                alt="公司荣誉"
                v-lazy="require('../assets/goin/'+honor.Img)"
                @click="dialogTableVisible = true ;dialogUrl = require('../assets/goin/'+honor.Img);dialogTitle= honor.Remark"
              />
            </li>
          </ul>
          <p>点击图片查看大图</p>
        </div>
        <!-- 团队风采 -->
        <div class="content-team">
          <div class="top">
            <h3>团队风采</h3>
            <p>TEAM</p>
          </div>
          <el-carousel :interval="4000" type="card">
            <el-carousel-item v-for="(team,index) in teamItem" :key="index">
              <!-- <div class="swiper-img" v-lazy:background-image="imgserver + team.Img"></div> -->
              <div class="swiper-img" v-lazy:background-image="require('../assets/goin/'+team.Img)"></div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <!-- 合作伙伴 -->
        <div class="content-partner">
          <div class="top">
            <h3>合作伙伴</h3>
            <p>RARTNERS</p>
            <ul class="partner-img">
              <li v-for="(partner,i) in partnerImg" :key="i">
                <img v-lazy="require('../assets/goin/'+partner.Img)" alt="合作伙伴" />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    Banner,
    swiper,
    swiperSlide
  },
  data() {
    return {
      loading: false,
      // honorList: [],//公司荣誉
      // partnerImg: [],//合伙
      courseList: [],
      // teamItem: [],//团队
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      dialogTableVisible: false,
      dialogUrl: "",
      dialogTitle: ""
    };
  },
  computed:{
    honorList:function(){
      return this.$store.state.honoralAll
    },
    teamItem:function(){
      return this.$store.state.teamAll
    },
    partnerImg:function(){
      return this.$store.state.partnerAll
    }
  },
  mounted() {

    // return;
    console.log(document.getElementsByClassName('content')[0].innerHTML.length)
    // this.$http
    //   .all([
    //     // this.$http.get("Honor/GetHonorAll"),
    //     // this.$http.get("Enterprise/GetEnterpriseAll"),
    //     // this.$http.get(`Team/GetTeamAll`),
    //     this.$http.get(`Course/GetCourseAll`)
    //   ])
    //   .then(
    //     this.$http.spread(
    //       (responseHonor, responseEnterprise, responseTeam, responseCourse) => {
    //         // this.honorList = responseHonor.data;
    //         // this.partnerImg = responseEnterprise.data;
    //         // this.teamItem = responseTeam.data;

    //         var groupCount = Math.ceil(responseCourse.data.length / 2);
    //         window.console.log(groupCount);
    //         for (let i = 0; i < groupCount; i++) {
    //           let img2 = [];
    //           for (let j = 0; j < 2; j++) {
    //             if (responseCourse.data.length - 1 >= i * 2 + j) {
    //               img2.push(responseCourse.data[i * 2 + j]);
    //             }
    //           }
    //           this.courseList.push(img2);
    //         }
    //         window.console.log(this.courseList);
    //         this.loading = false;
    //       }
    //     )
    //   );
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.go-in {
  width: 100%;
  height: 100%;
  background-color: #14679f;
  position: relative;
  overflow: hidden;
  .section {
    width: 100%;
    &-content {
      // width: 1240px;
      margin: 0 auto;
      background-color: #fff;

      .content-summary {
        //height: 500px;
        display: flex;
        justify-content: space-around;
        padding: 100px 20px;
        flex-wrap:wrap;
        .summary-left {
          width: 600px;
          .title {
            font-size: 25px;
            color: #e13834;
          }
          .eTitle {
            font-size: 17px;
            color: #e13834;
            padding: 20px 0;
          }
          .content {
            color: #14679f;
            font-size: 14px;
            text-indent: 25px;
            line-height: 30px;
            white-space:pre-wrap;
          }
        }

        .summary-right {
          transition:all .6s;
          width: 400px;
          height: 310px;
          border: 2px solid #1d42b9;
          //animation: imgboxkey 4s infinite;
          border-radius: 10px;
          margin-top: 80px;
          text-align: center;

          img {
            transition:all .6s;
            width: 360px;
            height: 270px;
            margin-top: 20px;
            //animation: imgbo 4s infinite;
          }
        }
      }

      //发展历程
      .content-course {
        padding: 50px 0;
        .course-time {
          max-width: 1000px;
          height: 400px;
          margin: 20px auto;
          .swiper-container {
            height: 100%;
          }
          .time-show {
            // width: 700px;
            height: 100%;
            // margin: 0 auto;
            padding: 0 20px;
            display: flex;
            justify-content:center;
            .time-show-item {
              width: 350px;
              height: 100%;
              overflow: hidden;
              display: flex;
              flex-direction: column;
              transition:all 0.3s;
              .item-top,
              .item-bottom {
                height: 190px;
              }
              .item-bottom {
                // display: flex;
                // align-content: center;
                .item-bottom-content {
                  background-color: #1667a0;
                  margin: 20px 0;
                  p {
                    color: #fff;
                    text-align: center;
                    padding: 15px;
                  }
                }
              }
            }
          }
        }
      }

      //企业文化
      .content-culture {
        height: 450px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        padding-left: 100px;
        background-color: #c2daeb;
        transition:all .6s;
        h3 {
          color: #3c6088;
          font-size: 26px;
        }
        p {
          color: #3c6088;
          font-size: 26px;
          padding: 5px 0;
        }
        span {
          font-weight: 400;
          line-height: 36px;
          font-size: 18px;
          padding: 5px 0;
        }
      }

      //公司荣誉
      .content-honor {
        padding: 50px 0;
        .honor-show {
          max-width: 1000px;
          margin: 0px auto;
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          align-content: flex-start;

          li {
            width: 220px;
            height: 320px;
            margin-left: 15px;
            list-style: none;
            border: 1px solid palegoldenrod;
            margin-top:20px;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        p {
          text-align: center;
          color: #3c6088;
        }
      }

      //团队风采
      .content-team {
        transition:all .6s;
        padding: 50px 100px;
        .swiper-img {
          height: 400px;
          background: no-repeat center;
          background-size: cover;
        }
      }

      //合作伙伴
      .content-partner {
        padding: 50px 0;
        .partner-img {
          max-width: 950px;
          margin: 20px auto;
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          li {
            width: 107px;
            height: 107px;
            list-style: none;
            margin: 10px 25px;

            img {
              width: 100%;
              height: 100%;
              border: 1px solid rgb(194, 218, 235);
            }
          }
        }
      }
    }
  }
}

@keyframes imgboxkey {
  0% {
    border: solid rgb(29, 66, 185) 2px;
  }
  40% {
    border: solid rgb(255, 255, 255) 2px;
  }
  60% {
    border: solid rgb(255, 255, 255) 2px;
  }
  100% {
    border: solid rgb(29, 66, 185) 2px;
  }
}

@keyframes imgbo {
  0% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
  50% {
    transform: scale(1.1);
    box-shadow: 0px 0px 10px 5px #ababab;
  }
  100% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
}
.el-divider--horizontal {
  margin: 1px 0;
}

.top {
  h3,
  p {
    text-align: center;
    color: #3c6088;
    font-weight: 400;
    padding: 10px 0;
  }
  h3 {
    font-size: 30px;
  }
  p {
    font-size: 20px;
  }
  .border {
    border-bottom: 1px solid #3c6088;
    width: 15%;
    margin: 0 auto;
  }
}
// .swiper-button-disabled {
//   display: none;
// }
.order {
  order: -1;
}
.order-top {
  order: 1;
}
.el-divider {
  background-color: red;
  height: 3px;
  .el-divider__text {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    padding: 0px;
    color: #fff;
    border: 3px solid red;
  }
}
.el-divider-active {
  background-color: #3c6088;
}
.honor-big-img {
  width: 100%;
  height: 100%;
  z-index: 10;
  text-align: center;
  padding-bottom: 20px;
  padding: 5%;
  //background-color: #14679f;
  .el-dialog__wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;

    .el-dialog__body {
      overflow: hidden;
      img {
        width: 100%;
      }
    }
  }
}
/deep/ .el-dialog{
    width:647px!important;
  }
@media screen and(max-width:960px){
  .go-in{
    .section-content{
      .content-team{
        padding: 50px 50px!important;
      }
    }
  }
}
@media screen and(max-width:648px){
  /deep/ .el-dialog{
    width:98%!important;
  }
  .go-in{
    .section-content{
      .content-team{
        padding: 50px 0px!important;
      }
      .content-course{
        .course-time{
        }
      }
      .content-culture{
        padding:50px;
        p{
          font-size: 23px;
          padding: 22px 0;
        }
        span{
          line-height: 33px;
          font-size: 16px;
        }
      }
    }
  }
}
@media screen and(max-width:470px){
  .go-in{
    .section-content{
      .content-summary{
        .summary-right{
          width:90%;
          height:250px;
          img{
            width:92%;
            height:210px;
          }
        }
      }
    }
  }
}
@media screen and(max-width:320px){
  .go-in{
    .section-content{
      .content-course{
        .course-time{
          .time-show{
            .time-show-item{
              font-size:12px;
            }
          }
        }
      }
      .content-culture{
        padding:20px!important;
      }
    }
  }
}

</style>